export const isProdStage = (env: NodeJS.ProcessEnv) => {
  return Boolean(env.VUE_APP_CONFIG_NAME && env.VUE_APP_CONFIG_NAME.toLowerCase().includes('prod'));
};

export const isProdOrStgStage = (env: NodeJS.ProcessEnv) => {
  return Boolean(env.VUE_APP_CONFIG_NAME &&
    (env.VUE_APP_CONFIG_NAME.toLowerCase().includes('prod') || env.VUE_APP_CONFIG_NAME.toLowerCase().includes('stg')));
};

export const isDevStage = (env: NodeJS.ProcessEnv) => {
  return env.VUE_APP_CONFIG_NAME?.toLowerCase() === 'mimir-dev';
};

export const getVueAppConfigName = (env: NodeJS.ProcessEnv) => env.VUE_APP_CONFIG_NAME?.toLowerCase();
